import { render, staticRenderFns } from "./PagingFooter.vue?vue&type=template&id=6d160e12"
import script from "./PagingFooter.vue?vue&type=script&lang=js"
export * from "./PagingFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1166467537/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d160e12')) {
      api.createRecord('6d160e12', component.options)
    } else {
      api.reload('6d160e12', component.options)
    }
    module.hot.accept("./PagingFooter.vue?vue&type=template&id=6d160e12", function () {
      api.rerender('6d160e12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PagingFooter.vue"
export default component.exports